(function () {
  'use strict';
  let token = '', pending = null;
  function base() {
    return new URL(document.querySelector('.border-generator').dataset.apiEndpoint, window.location.href);
  }
  function target(path) {
    const origin = base();
    const url = new URL(path, origin);
    if (url.origin !== origin.origin || !/^\/(api\/|upload\/|download\/)/.test(url.pathname)) {
      throw new Error('The export service returned an unexpected address.');
    }
    return url.href;
  }
  async function session(signal) {
    if (pending) return pending;
    pending = (async () => {
      // Session renewal is shared by overlapping selections. Aborting one file
      // must not abort renewal for the replacement selected immediately after it.
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      let response;
      try {
        response = await fetch(new URL(base().pathname.replace(/\/$/, '') + '/session', base()).href, {
          method: 'POST', credentials: 'omit', cache: 'no-store', signal: controller.signal,
          headers: token ? {Authorization: 'Bearer ' + token} : {}
        });
      } finally { clearTimeout(timer); }
      const result = await response.json();
      if (!response.ok) throw new Error(result.error || 'Session renewal failed. Please retry.');
      if (result.token) token = result.token;
      if (!token) throw new Error('The export session could not be verified.');
      return result;
    })();
    try { return await pending; } finally { pending = null; }
  }
  async function authorizedFetch(path, options = {}) {
    const url = target(path);
    const headers = new Headers(options.headers || {});
    if (token) headers.set('Authorization', 'Bearer ' + token);
    return fetch(url, {...options, headers, credentials: 'omit', cache: 'no-store'});
  }
  window.StackhouseBorderSession = {fetch: authorizedFetch, renew: session, cancel: function (jobId) {
    if (!token || !jobId) return;
    authorizedFetch(new URL(base().pathname.replace(/\/$/, '') + '/cancel', base()).href,
      {method: 'POST', keepalive: true, headers: {'Content-Type': 'application/json'}, body: JSON.stringify({job_id: jobId})}).catch(() => {});
  }};
  window.StackhouseBorderUploadPolicy = {validateBeforeUpload: async function (file, options = {}) {
    if (file.size > 64 * 1024 * 1024) return {valid: false, error: 'Use a file no larger than 64 MB.'};
    try {
      await session(options.signal);
      const response = await authorizedFetch(new URL(base().pathname.replace(/\/$/, '') + '/validate-upload', base()).href,
        {method: 'POST', body: file, signal: options.signal});
      const result = await response.json();
      return response.ok ? result : {valid: false, error: result.error};
    } catch (error) {
      if (error.name === 'AbortError') throw error;
      return {valid: false, error: error.message || 'The validation connection was interrupted. Select the file again to retry.'};
    }
  }};
})();
